import React from "react";
import { InputNumber, ConfigProvider } from "antd";

/**
 * Custom InputNumber Component
 */
const InputNumberField = ({
  hoverBorder = false,
  size = "large",
  placeholder = "",
  value,
  disabled = false,
  onChange,
  onBlur,
  onFocus,
  step=1,
  precision=2,
  style = {},
  className = "",
  formatter=undefined,
  parser=undefined,
  ...rest
}) => {
  //   const theme = {
  //     token: {
  //       borderRadius: "4px",
  //       colorPrimary: "#1890ff",
  //       inputPadding: "8px",
  //     },
  //   };

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            paddingBlock: 6,
            borderRadius: 6,
            colorBgContainer: "#ffffff",
            colorBorder: "#d9d9d9",
          },
          InputNumber: {
          paddingBlock: 6,
          borderRadius: 6,
          colorBgContainer: "#ffffff",
          colorBorder: "#d9d9d9",
          colorText: "#333",
      },
        },
      }}
    >
      <InputNumber
        size={size}
        type="number"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        step={step}
        // defaultValue={0}
        precision={precision}
        onChange={onChange}        
        onBlur={onBlur}
        onFocus={onFocus}
        formatter={formatter}
        parser={parser}
        style={{
          width: "100%",
          ...style
        }}
        onWheel={(e) => e.target.blur()}
        className={`${hoverBorder ? "custom-input-hover" : ""} ${className}`}
        {...rest}
      />
    </ConfigProvider>
  );
};

export default InputNumberField;
